import AssignedServiceProvider from './submarkers/AssignedServiceProvider';
import GenericServiceProvider from './submarkers/GenericServiceProvider';

export const QUADRANT_GAP = 6;

// Here theme is needed since this returns svg as html not react
function ServiceProvider({
  serviceProvider,
  onClickHandler,
  index,
  location,
  size = 'medium',
  type = 'GENERIC',
  nonGenericTypeHidePointer = false,
  theme,
  MapLib,
}) {
  let svg = null;
  if (type === 'ASSIGNED_OR_ACCEPTED') {
    svg = AssignedServiceProvider({
      number: parseInt(index, 10) + 1,
      nonGenericTypeHidePointer,
      location,
      ...(nonGenericTypeHidePointer ? { height: 35 } : {}),
    });
  } else {
    svg = GenericServiceProvider({
      serviceProvider,
      index,
      theme,
      size,
      location,
      gap: QUADRANT_GAP,
    });
  }

  svg.setAttribute(
    'id',
    MapLib.serviceProviderGetMarkerId(serviceProvider?.id, location?.id),
  );
  svg.setAttribute('data-index', index);
  svg.setAttribute('class', `map_clickable`);

  svg.addEventListener('click', e => {
    if (onClickHandler) {
      onClickHandler({ e, sp: serviceProvider, location });
    }
  });

  return svg;
}

export default ServiceProvider;
